export default "__VITE_ASSET__BVY44TK1__"